import { connect } from '../../../../common/react-redux';
import { screenreaderNotification } from '../../../../common/actions/alerts';
import { OutcomeAnalysis as OutcomeAnalysisPresenter } from './presenter';
export function mapStateToProps(state) {
  return {
    appContainer: state.getIn(['ui', 'appContainer']),
    contextUuid: state.getIn(['outcomes', 'contextUuid']),
    outcomesHost: state.getIn(['outcomes', 'outcomesEndpoint']),
    outcomesToken: state.getIn(['outcomes', 'outcomesToken'])
  };
}
var mapDispatchToProps = {
  screenreaderNotification: screenreaderNotification
};
export var OutcomeAnalysis = connect(mapStateToProps, mapDispatchToProps)(OutcomeAnalysisPresenter);
export default OutcomeAnalysis;